// extracted by mini-css-extract-plugin
module.exports = {"performance":"LoadingIndicator_performance__1hBlK","rotation":"LoadingIndicator_rotation__1m2la"};